import { axios } from '../internal';
const URI = '/preferences/preferences';
const CURRENT_USER = '@currentUser';
export const setPreferences = async (data, options = {}) => {
  const config = Object.assign(options, {
    headers: {
      Accept: 'application/vnd.sas.collection+json',
      contentType: 'application/vnd.sas.collection+json'
    }
  });
  const url = `${URI}/${CURRENT_USER}`;
  const response = await axios.put(url, data, config);
  return response.data;
};
export const getPreferences = async (options = {}) => {
  const config = Object.assign(options, {
    headers: {
      Accept: 'application/vnd.sas.collection+json'
    }
  });
  const url = `${URI}/${CURRENT_USER}`;
  const response = await axios.get(url, config);
  return response.data;
};
export const getPreference = async (id, options = {}) => {
  const config = Object.assign(options, {
    headers: {
      Accept: 'application/vnd.sas.preference+json'
    }
  });
  const url = `${URI}/${CURRENT_USER}/${id}`;
  const response = await axios.get(url, config);
  return response.data;
};
export const deletePreferences = async (keys, options = {}) => {
  const data = keys.map(key => ({
    id: key
  }));
  const config = Object.assign(options, {
    data: {
      items: data
    },
    headers: {
      Accept: 'application/vnd.sas.collection+json',
      contentType: 'application/vnd.sas.collection+json'
    }
  });
  const url = `${URI}/${CURRENT_USER}`;
  return axios.delete(url, config);
};
//# sourceMappingURL=preferences.js.map